export default "__VITE_ASSET__ef98c346__"